import { StrictMode } from "react";
import { I18nextProvider } from "react-i18next";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import ReactDOM from "react-dom/client";
import i18n from "@/_old/config/i18n";

import { Router } from "./core/routes";
import { queryClient } from "./core/config";
import { TraceProvider } from "@woba/logger-web/react";
import { wobaLogger } from "./core/config/woba-logger";

import "@/_old/config/clarity";
import "@/_old/config/hotjar";
import "@/core/config/datadog-rum";
import "@/_old/config/open-telemetry";
import "@/_old/config/user-guiding";

import "./global.css";
import "./fonts/ds-fk-grotesk-alias.css";

console.log("Versão do build:", __BUILD_TIMESTAMP__);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <TraceProvider logger={wobaLogger}>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <Router />
        </I18nextProvider>
        {process.env.NODE_ENV === "development" && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </TraceProvider>
  </StrictMode>,
);
